// extracted by mini-css-extract-plugin
module.exports = {"expectedRoot":"EventExpectedParticipants_expectedRoot__2lnYP","plusMinus":"EventExpectedParticipants_plusMinus__3I_--"};